import { connect } from 'react-redux';

import appSelectors from 'selectors/app';
import uiEvents from 'events/ui';
import userSelectors from 'selectors/user';
import { SecurePaymentForm } from 'presentation/components/SecurePaymentForm';

export const mapStateToProps = state => {
  return {
    gladlyCustomerId: userSelectors.getGladlyCustomerId(state.user),
    orgId: appSelectors.getOrgId(state),
    vaultId: appSelectors.getVaultId(state),
    secureOrgId: appSelectors.getSecureOrgId(state),
  };
};

export const mapDispatchToProps = dispatch => {
  return {
    onDecline: () => {
      dispatch(uiEvents.navigateBack());
    },
  };
};

const SecurePaymentFormContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(SecurePaymentForm);

export default SecurePaymentFormContainer;
